import { render, staticRenderFns } from "./AdminSessionDetail.vue?vue&type=template&id=088b5176&scoped=true&"
import script from "./AdminSessionDetail.vue?vue&type=script&lang=js&"
export * from "./AdminSessionDetail.vue?vue&type=script&lang=js&"
import style0 from "./AdminSessionDetail.vue?vue&type=style&index=0&id=088b5176&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088b5176",
  null
  
)

export default component.exports